import Decimal from 'decimal.js';

import { LegalRepresentative, Occupant } from 'src/shared/types/basket-types';

import { SelectedPriceDto } from './SelectedPrice.dto';

export class CreateBasketProductDto {
    readonly id: string;

    readonly room_code: string;

    readonly academic_year: string;

    readonly building_id: string;

    readonly development_id: string;

    readonly price: string;

    readonly currency: string;

    readonly deposit: string;

    readonly advance_payment_weeks: number;

    readonly deposit_prepaid: boolean;

    readonly selected_students: number;

    readonly term: string;

    readonly beds: number;

    readonly payment_plan_id: string;

    readonly instalment_type: string;

    readonly cbl: boolean;

    readonly stl: boolean;

    readonly occupants: Occupant[];

    readonly selected_price: SelectedPriceDto;

    readonly legal_representative: LegalRepresentative;

    readonly promotion_id: string | null;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(rawBasketProduct: any) {
        this.id = rawBasketProduct.id;
        this.room_code = rawBasketProduct.room_code;
        this.academic_year = rawBasketProduct.academic_year;
        this.building_id = rawBasketProduct.building_id;
        this.development_id = rawBasketProduct.development_id;
        this.price = new Decimal(rawBasketProduct.price).toFixed(2);
        this.currency = rawBasketProduct.currency;
        this.deposit = new Decimal(rawBasketProduct.deposit ?? 0).toFixed(2);
        this.advance_payment_weeks = rawBasketProduct.advance_payment_weeks;
        this.deposit_prepaid = rawBasketProduct.deposit_prepaid;
        this.selected_students = rawBasketProduct.selected_students;
        this.term = rawBasketProduct.term;
        this.beds = rawBasketProduct.beds;
        this.payment_plan_id = rawBasketProduct.payment_plan_id;
        this.instalment_type = rawBasketProduct.instalment_type;
        this.cbl = rawBasketProduct.cbl;
        this.stl = rawBasketProduct.stl;
        this.occupants = rawBasketProduct.occupants;
        this.selected_price = new SelectedPriceDto(rawBasketProduct.selected_price);
        this.legal_representative = rawBasketProduct.legal_representative;
        this.promotion_id = rawBasketProduct.promotion_id;
    }
}
